module.exports = "/images/account_pic.png?929e5ca92549396607f0e695b062956b";